import { useState, useEffect } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import './Theme.css'

export default function Theme({asButton = true, className = ''}) {
    const storedDarkTheme = JSON.parse(localStorage.getItem('darkMode'))
    const [darkTheme, setDarkTheme] = useState(storedDarkTheme ? storedDarkTheme : false)

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', darkTheme ? 'dark' : 'light')
        localStorage.setItem('darkMode', JSON.stringify(darkTheme))
    }, [darkTheme])

    const onClickThemeButton = e => {
        e.preventDefault()
        setDarkTheme(!darkTheme)
    }

    const icon = darkTheme ? <FontAwesomeIcon icon="fa-solid fa-sun" /> : <FontAwesomeIcon icon="fa-solid fa-moon" />

    return asButton ? <button className='tda-themeButton' onClick={onClickThemeButton}>{icon}</button> : <div className={className} onClick={onClickThemeButton}>{icon}</div>
}